import { render } from "./TrafficTable.vue?vue&type=template&id=42fc2e0c&scoped=true"
import script from "./TrafficTable.vue?vue&type=script&lang=js"
export * from "./TrafficTable.vue?vue&type=script&lang=js"

import "./TrafficTable.vue?vue&type=style&index=0&id=42fc2e0c&lang=scss&scoped=true"
import "./TrafficTable.vue?vue&type=style&index=1&id=42fc2e0c&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fc2e0c"]])

export default __exports__